import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import { usePost } from 'hooks';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { exportTemplateActions as actions } from 'reducers/exportTemplate/reducer';
import { exportTemplates } from 'services/api';
import { errorResToMessageArray } from './errorResToMessageArray';

const SuccessIcon = (
  <CheckCircleOutlined style={{ fontSize: 20, color: 'green' }} />
);
const ErrorIcon = (
  <CloseCircleOutlined style={{ fontSize: 20, color: 'red' }} />
);

export const useCreateTemplateMutation = (
  _onRequestSuccess,
  _onRequestError
) => {
  const dispatch = useDispatch();

  const onRequestError = useCallback(
    res => {
      notification.open({
        icon: ErrorIcon,
        message: 'Error',
        description: (
          <div>
            Failed to create template.
            {errorResToMessageArray(res).map(err => (
              <p key={err} style={{ fontSize: 12, color: '#666' }}>
                {err}
              </p>
            ))}
          </div>
        ),
        placement: 'bottomLeft',
      });
      _onRequestError?.();
    },
    [_onRequestError]
  );

  const onRequestSuccess = useCallback(
    res => {
      dispatch(actions.serverMutationOccurred());
      // Select the just-created template; the refetch's sticky rule preserves it
      dispatch(actions.templateSelectionChanged(res.id));
      notification.open({
        icon: SuccessIcon,
        message: 'Success',
        description: 'Template created successfully',
        placement: 'bottomLeft',
      });
      _onRequestSuccess?.(res);
    },
    [_onRequestSuccess, dispatch]
  );

  const [{ loading: createLoading }, sendCreate] = usePost({
    url: exportTemplates,
    configuration: {
      onRequestSuccess,
      onRequestError,
    },
  });

  const triggerCreate = useCallback(
    payload => {
      sendCreate({ body: payload });
    },
    [sendCreate]
  );

  return {
    triggerCreate,
    createLoading,
  };
};
